import {ModuleTopic, Progress} from '@cp/model';
import extractProgressStudyProgress from '../extractProgressStudyProgress';

export default function calculateAverageStudyProgress(
  topics: ModuleTopic[],
  progress: Progress | null | undefined,
): number {
  if (topics.length === 0) return 0;
  if (!progress) return 0;
  const progressValues = topics.map((topic) => extractProgressStudyProgress(progress, topic));
  const sum = progressValues.reduce((acc, p) => acc + p, 0);
  return sum / topics.length;
}
